import { Button, Dialog, DialogActions } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

const DeleteDialog = ({ onClose, onDelete, children }) => {
  const intl = useIntl();

  return (
    <Dialog open onClose={onClose}>
      {children}
      <DialogActions>
        <Button onClick={onClose}>
          {intl.formatMessage({
            id: "Shared.DeleteDialog.Cancel",
            defaultMessage: "Cancel"
          })}
        </Button>
        <Button variant="contained" color="primary" size="small" onClick={onDelete}>
          {intl.formatMessage({
            id: "Shared.DeleteDialog.Confirm",
            defaultMessage: "Yes, remove."
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
